import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from '../auth.service';
import {FormsModule} from '@angular/forms';
import {NgOptimizedImage} from '@angular/common';
import {ErrorAlertComponent} from '../../components/error-alert.component/error-alert.component';
import {MatFormFieldModule} from '@angular/material/form-field';
import {MatInputModule} from '@angular/material/input';
import {MatIconModule} from '@angular/material/icon';
import {MatButtonModule} from '@angular/material/button';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  imports: [
    FormsModule,
    NgOptimizedImage,
    ErrorAlertComponent,
    MatFormFieldModule,
    MatInputModule,
    MatIconModule,
    MatButtonModule,
  ],
  styleUrls: ['./login.component.css']
})
export class LoginComponent {
  email = '';
  password = '';
  forgotPasswordEmail = '';
  loading = false;
  error: string | null = null;
  forgotPasswordMode = false;
  forgotPasswordSent = false;
  showPassword = false;

  constructor(private auth: AuthService, private router: Router) {}

  login() {
    this.loading = true;
    this.error = null;

    this.auth.login(this.email, this.password).subscribe({
      next: () => {
        this.loading = false;
        this.router.navigate(['/dashboard']);
      },
      error: () => {
        this.loading = false;
        this.error = 'Погрешна е-пошта или лозинка.';
      }
    });
  }

  togglePasswordVisibility(): void {
    this.showPassword = !this.showPassword;
  }

  openForgotPassword(): void {
    this.forgotPasswordMode = true;
    this.forgotPasswordSent = false;
    this.error = null;
    this.password = '';
  }

  backToLogin(): void {
    this.forgotPasswordMode = false;
    this.forgotPasswordSent = false;
    this.error = null;
    this.forgotPasswordEmail = '';
  }

  sendResetPassword(): void {
    this.loading = true;
    this.error = null;
    this.forgotPasswordSent = false;

    this.auth.forgotPassword(this.forgotPasswordEmail).subscribe({
      next: () => {
        this.loading = false;
        this.forgotPasswordSent = true;
      },
      error: () => {
        this.loading = false;
        this.error = 'Не можевме да го испратиме барањето. Обидете се повторно.';
      }
    });
  }
}
